import Api from './Api';

const GetCommentsId = (id) => {
  return Api().get(`/comment/${id}`);
};
const GetComments = (id) => {
  return Api().get(`/comment/anonymous-contact/${id}`);
};

const PostComments = (dados) => {
  return Api().post('/comment/', dados);
};

const PatchComments = (id, reactions) => {
  return Api().patch(`/comment/reactions/${id}`, reactions);
};

const GetCommentsAll = () => {
  return Api().get('/comment');
};
const GetAnonymousCon = () => {
  return Api().get('/anonymous-contact');
};
const deleteComment = (id) => {
  return Api().delete(`/comment/${id}`);
};

export {
  PostComments,
  GetAnonymousCon,
  GetComments,
  GetCommentsId,
  PatchComments,
  GetCommentsAll,
  deleteComment,
};
